var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.user.orcid_id)?_c('orcid-button',{attrs:{"text":"Connect with ORCID ","containerClass":"mt-4 mb-0","isConnect":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }